export enum MealOption {
	BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
	HALF_BOARD_INCLUDED = 'HALF_BOARD_INCLUDED',
	FULL_BOARD_INCLUDED = 'FULL_BOARD_INCLUDED',
	NOT_INCLUDED = 'NOT_INCLUDED',
}

export const MEAL_OPTIONS = [MealOption.NOT_INCLUDED, MealOption.BREAKFAST_INCLUDED, MealOption.HALF_BOARD_INCLUDED, MealOption.FULL_BOARD_INCLUDED];
